/**
 * @classdesc Vietnamese Language Pack
 * @desc This class will used to translate tokens into the Vietnamese language.
 * @namespace Languages.Vietnamese
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Vietnamese
 */
export const dictionary = {
	'years'   : 'Năm',
	'months'  : 'Tháng',
	'days'    : 'Ngày',
	'hours'   : 'Giờ',
	'minutes' : 'Phút',
	'seconds' : 'Giây'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Vietnamese
 */
export const aliases = ['vn', 'vn-vn', 'vietnamese'];
